import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  orderStatuses: {},
  loading: false,
};

const getOrderStatuses = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.ORDER_STATUSES_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.ORDER_STATUSES_SUCCESS:
      return {
        ...state,
        loading: false,
        orderStatuses: payload.data,
      };
    case actionTypes.ORDER_STATUSES_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default getOrderStatuses;
